import { FC } from 'react';

import { GetBoInvestorProfileIdEndpoint } from '@Common/types/bo/b2b/investor_profile';

import { B2bInvestorProfileShowGrid } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileShowGridWrapper/components/B2bInvestorProfileShowGrid/B2bInvestorProfileShowGrid';
import { B2bInvestorProfileShowSicavGrid } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileShowGridWrapper/components/B2bInvestorProfileShowSicavGrid/B2bInvestorProfileShowSicavGrid';

interface Props {
  allocation: GetBoInvestorProfileIdEndpoint['Client']['ResponseBody']['allocations'];
  productCategory: GetBoInvestorProfileIdEndpoint['Client']['ResponseBody']['plan_category'];
  profileType: GetBoInvestorProfileIdEndpoint['Client']['ResponseBody']['risk_profile'];
}

export const B2bInvestorProfileShowGridWrapper: FC<Props> = (props) => {
  const { allocation, productCategory, profileType } = props;

  if (profileType === 'sicav') {
    return <B2bInvestorProfileShowSicavGrid allocation={allocation} />;
  }

  return <B2bInvestorProfileShowGrid allocation={allocation} productCategory={productCategory} />;
};
